
import React, { useState } from 'react'
import { X } from 'react-feather'
import Box from './Box'

/**
 * TagInput component.
 */

export default function TagInput({ defaultValue = [], ...props }) {
  const [values, setValues] = useState(defaultValue)

  function add(input) {
    setValues(values.concat(input))
  }

  function remove(value, index) {
    setValues(values.filter((_, i) => i != index))
  }

  return <StatelessTagInput
    values={values}
    onAdd={add}
    onRemove={remove}
    {...props} />
}

/**
 * StatelessTagInput component.
 */

function StatelessTagInput({ name, required, values = [], onAdd, onRemove, ...props }) {
  const [focus, setFocus] = useState(false)

  function add(e) {
    const value = e.target.value.trim()
    e.preventDefault()
    e.target.value = ''
    if (value != '') onAdd(value)
  }

  function keydown(e) {
    // backspace — remove
    if (e.keyCode == 8) {
      const value = e.target.value
      // remove last
      if (value.trim() == '') {
        e.preventDefault()
        const index = values.length - 1
        const last = values[index]
        onRemove(last, index)
      }
    }

    // enter — add
    if (e.keyCode == 13) {
      add(e)
    }
  }
  
  function blur(e) {
    setFocus(false)
    add(e)
  }

  return <Box classes={['TagInput', focus && 'focus']}>
    {values.map((v, i) => {
      return <Tag key={i} onRemove={_ => onRemove(v, i)}>
        {v}
      </Tag>
    })}

    <Box
      is="input"
      type="hidden"
      name={name}
      required={required}
      value={values.join(',')} />

    <Box
      is="input"
      className="Input"
      placeholder="Add..."
      onFocus={_ => setFocus(true)}
      onBlur={blur}
      onKeyDown={keydown}
      {...props} />
  </Box>
}

/**
 * Tag component.
 */

function Tag({ children, onRemove }) {
  return <Box className="Tag">
    {children}
    <X className="icon" onClick={onRemove} />
  </Box>
}